import useServiceFactory from "../serviceFactory";
const apiUrl = `/taller/almacen/requisicion`;
const apiUrlSource = `/source`;
const apiUrlOrdenTrabajo = `/taller/mantenimiento/ordenesTrabajo`;
const useApiRequisicion = () => {
    const service = useServiceFactory({ uri: process.env.REACT_APP_API_URL });

    return {
        filtrar: async (params) => service.get(`${apiUrl}`, {params, showLoading: true}),
        obtener: async (id) => service.get(`${apiUrl}/${id}`, {}),
        guardar: async (formData) => service.post(`${apiUrl}`, formData),
        cambiarEstatus: async (id, formData) => service.put(`${apiUrl}/${id}/autorizar`, formData),
        cambiarFechaEntrega: async (id, formData) => service.put(`${apiUrl}/${id}/cambiarFechaEntrega`, formData),
        autorizar: async (id, formData) => service.put(`${apiUrl}/${id}/autorizarRequisicion`, formData),
        rechazar: async (id, formData) => service.put(`${apiUrl}/${id}/rechazar`, formData),
        obtenerArticulos: async (id) => service.get(`${apiUrl}/articulos/${id}`, {}),
        agregarArticulos: async (id, formData) => service.post(`${apiUrl}/${id}/articulos`, formData),
        getEstatus: async () => service.get(`${apiUrlSource}/estatusRequisicionesArticulos/`, { showLoading: true }),
        getCategorias: async () => service.get(`${apiUrlSource}/categoriaRequisicionesArticulos/`, { showLoading: true }),
        asignarOrdenTrabajo:async (id,ids) => service.put(`${apiUrlOrdenTrabajo}/asignarOrdenTrabajo/${id}/${ids}`, { showLoading: true }),
        excel: async (params) => service.get(`${apiUrl}/excel`,
        {
            params,
            showLoading: true,
            download: true,
            fileName: `Requisiciones.xlsx`
        }),
    }
};

export default useApiRequisicion;
